module.exports = __webpack_public_path__ + "img/interior-design-of-home-1643383.95e1dc22.jpg";